<template>
    <div class="wgCalcLeftCol">
        <slot>

        </slot>

    </div>
</template>
<script>
export default {
    name: 'LeftColumn'
}
</script>
<style lang="scss">
    .wgCalc{
        &LeftCol{
            background: 20% center no-repeat;
            background-size: cover;
            @media only screen and (max-width: 755px){
                height: 400px;
                padding-bottom: 80px;
            }
        }
    }
</style>
